import React from 'react'
import styled from 'styled-components'
import Colors from 'styles/colors'
import { spacing, fontSize } from 'frontend_core/dist/styles/variables'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { amplitudeLogEvent } from 'helpers/amplitude'

export default props => {
  const { isSpLayout } = props

  const googleLoginHandler = () => {
    amplitudeLogEvent('Select Login', { Type: 'Google' })
    // userAgentからLINE or InstagramのWebviewであるかを判定
    // @see: https://zenn.dev/kecy/articles/f51851e42c4243
    if (
      navigator.userAgent.includes('Line') ||
      navigator.userAgent.includes('Instagram')
    ) {
      alert(
        '外部サービスからGoogleアカウントでログインできません。Webブラウザかスペースマーケットのアプリからログインしてください。',
      )
      return
    }
    window.location.href = props.googleAuthUrl
  }

  // SP用レイアウトの場合はcolクラスを使わない
  const wrapperClassName = isSpLayout ? '' : 'col-sm-12 col-md-6'
  // SP用レイアウトの場合はmargin-bottomをなくす
  const snsListClassName = isSpLayout
    ? 'signup-box__sns signup-box__sns--no-margin'
    : 'signup-box__sns'

  return (
    <div className={wrapperClassName}>
      <h2 className="signup-box__title">{i18n.t('page.account.l_00020')}</h2>
      <ul className={snsListClassName}>
        <li>
          <GoogleLogIn onClick={googleLoginHandler}>
            <GoogleIconWrap>
              <img
                src={imagePath('common/logo-icon-google.svg')}
                width="18"
                alt={i18n.t('page.account.l_00023')}
              />
            </GoogleIconWrap>
            {i18n.t('page.account.l_00023')}
          </GoogleLogIn>
        </li>
      </ul>
    </div>
  )
}

const LogIn = styled.a`
  width: 100%;
  height: 100%;
  padding: ${spacing.medium}px;
  padding-left: 42px;
  border-radius: 6px;
  border: 1px solid;
  font-size: ${fontSize.medium}px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  position: relative;
  display: block;
`
const GoogleLogIn = styled(LogIn)`
  background-color: #4285f4;
  border: 1px solid #4285f4;
  border-radius: 6px;
  color: ${Colors.mono.white};
`
const GoogleIconWrap = styled.span`
  padding: 14px;
  display: block;
  background-color: white;
  position: absolute;
  left: 0px;
  top: 0px;
  border-radius: 5px 0 0 5px;
`
